export default __webpack_public_path__ + "static/media/video2.6884bbf6.mp4";